import { LocaleEnum } from '@systemeio/ui'
import { getPublicPath } from 'shared/utils/locale/get-locale-for-link'

const CONTACT_SUPPORT_PATH = '/support/contact-us'

export const getContactSupportLink = (locale: LocaleEnum) => {
  return getPublicPath(locale, CONTACT_SUPPORT_PATH)
}
